import script from "./BirthRecordNotarizationTracker.vue?vue&type=script&lang=ts&setup=true"
export * from "./BirthRecordNotarizationTracker.vue?vue&type=script&lang=ts&setup=true"

import "./BirthRecordNotarizationTracker.vue?vue&type=style&index=0&id=6c825187&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c825187"]])

export default __exports__